import React from "react";
import * as Comp from "../../app/features/AboutCourse";
import { GET_REQUEST } from "../../HooksApi/useApi";
import UseGetData from "../../HookAxios/getdata";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as Course from "../../app/features/AboutCourse/redux/actions";
import * as Sections from "../../app/features/AboutCourse/redux/actions";
import DotsLoader from "../../Components/Loader/Dots";
const AboutCourse = () => {
  const { idCourse } = useParams();
  const token = useSelector((state) => state.Auth.userInfo.token);
  console.log("the token is ", token)
  const dispatch = useDispatch();
  const AboutCourse = useSelector((state) => state.Courses.AboutCourse);
  let headers = {}
  if (token){
    headers = { Authorization: `Bearer ${token}` }
  }
  const { isLoading: LoadAboutCourse, data: dataAboutCourse } = GET_REQUEST({
    queryKey: `aboutCourse${idCourse}`,
    request: () =>
      UseGetData(
        "get_course_by_id",
        { id: idCourse },
        headers
      ),
    enabled: true,
  });
  
  const { isLoading: LoadDepartments, data: dataDepartments } = GET_REQUEST({
    queryKey: `GetSectionsCourse${idCourse}`,
    request: () =>
      UseGetData(
        "get_sections_by_id",
        { id: idCourse },
        headers
      ),
    enabled: true,
  });
  React.useEffect(() => {
    if (!LoadAboutCourse && dataAboutCourse?.data?.data?.courses)
      dispatch(Course.GetAboutCourse(dataAboutCourse.data.data.courses));
  }, [LoadAboutCourse]);
  React.useEffect(() => {
    if (!LoadDepartments && dataDepartments?.data?.data?.sections) {
      dispatch(
        Sections.GetSectionsByCourse(dataDepartments?.data?.data?.sections)
      );
    }
  }, [LoadDepartments]);

  return (
    <div>
      {!LoadAboutCourse &&
      AboutCourse.data &&
      dataAboutCourse?.data?.data?.courses ? (
        <>
          <Comp.Header
            duration={AboutCourse.data.duration}
            cost={AboutCourse.data.cost}
            cost2={AboutCourse.data.cost2}
            cost4={AboutCourse.data.cost4}
            cost5={AboutCourse.data.cost5}
            expiration_month={AboutCourse.data.expiration_month}
            name={AboutCourse.data.name}
            disc={AboutCourse.data.brief}
            image={AboutCourse.data.image_path}
            rate={AboutCourse.data.rate}
            teacher_name={AboutCourse.data.teacher_name}
            numberRate={AboutCourse.data.number_of_rater}
            dateCreate={AboutCourse.data.date_of_create}
            numberStudent={AboutCourse.data.number_of_student}
            subscribe={dataAboutCourse?.data?.data?.is_subscribtion}
            id={
              dataDepartments?.data?.data?.sections[0]
                ? dataDepartments?.data?.data?.sections[0]?.id
                : ""
            }
          />
          <Comp.CourseDiscSection
            teacherId={AboutCourse?.data?.teacher_id}
            LoadDepartments={LoadDepartments}
            dataDepartments={dataDepartments}
          />
        </>
      ) : (
        <DotsLoader />
      )}
    </div>
  );
};

export default AboutCourse;
